import {useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../store/slices/UserSlice";
const Header = () => {
  // redux state
  const { userObj } = useSelector((state) => state.user);
  const dispatch = useDispatch()
  return (
    <>
      <header className="text-white py-3 px-5 d-flex justify-content-between align-items-center headerCustom">
        <h4 className="mb-0 fw-bold header">Booking Management System</h4>
        <span className="text-light userEmail">
          {userObj?.userEmail}
          <i className="fa fa-solid fa-arrow-right-from-bracket" onClick={() => dispatch(clearUser())} title="Logout" style={{ marginLeft: "10px", cursor:"pointer" }}></i>
        </span>
      </header>
    </>
  );
};
export default Header;
